import { PatchworkApiReturnCodes, PatchworkRESTApiError } from "@patchwork/api/apireturncodes";
import { register } from "@patchwork/api/user/userapi";


async function registerUser() {
	let mailField = document.getElementById("mail") as HTMLInputElement;
	let usernameField = document.getElementById("login") as HTMLInputElement;
	let passwordField = document.getElementById("password") as HTMLInputElement;
	let passwordConfirmField = document.getElementById("password-confirm") as HTMLInputElement;
	let registerErrorHint = document.getElementById("login-error-hint") as HTMLParagraphElement;
	let registerForm = document.getElementById("register-form") as HTMLElement;
	let registerSuccess = document.getElementById("register-success") as HTMLButtonElement;
	let linkToLogin = document.getElementById("link-to-login") as HTMLLinkElement;

	if (mailField && usernameField && passwordField && passwordConfirmField) {
		if (!mailField.checkValidity()) {
			mailField.reportValidity();
			return;
		}
		if (!usernameField.checkValidity()) {
			usernameField.reportValidity();
			return;
		}
		if (!passwordField.checkValidity()) {
			passwordField.reportValidity();
			return;
		}
		if (!passwordConfirmField.checkValidity()) {
			passwordConfirmField.reportValidity();
			return;
		}
		if (!passwordConfirmField.checkValidity()) {
			passwordConfirmField.reportValidity();
			return;
		}


		registerErrorHint.hidden = true;
		let mail = mailField.value;
		let username = usernameField.value;
		let password = passwordField.value;
		let passwordConfirm = passwordConfirmField.value;
		if (mail !== "" && username !== "" && password !== "" && passwordConfirm !== "") {
			var result = await register(mail, username, password);
			if (result.unpack()) {
				registerSuccess.hidden = false;
				registerForm.hidden = true;
				linkToLogin.innerText = "Me connecter"
			} else {
				var error = result.error() as PatchworkRESTApiError;
				if (error.errorCode === PatchworkApiReturnCodes.USEREXISTSEXCEPTION) {
					registerErrorHint.hidden = false;
				}
			}
		}
	}
}


declare global {
	interface Window {
		registerPage : {
			registerUser : () => void
		}
	}
}

window.registerPage = window.registerPage || { registerUser : registerUser };
